import { ChangeDetectorRef, Component, HostListener, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'error-permission-location.component',
    templateUrl: './error-permission-location.component.html',
    styleUrls: ["./error-permission-location.component.css"],
})
export class ErrorPermissionLocationComponent implements OnInit {
    isRefSPay: boolean = false;
    defaultTouch = { x: 0, y: 0, time: 0 };
    idx = 0;
    preHandle = '';

    constructor(private cd: ChangeDetectorRef, private ngZone: NgZone, private router: Router) {
        if (this.router.getCurrentNavigation().extras.state) {
            this.isRefSPay = !!this.router.getCurrentNavigation().extras.state.Ref;
            localStorage.setItem("InfoPermission", JSON.stringify({ IsRefSpay: this.isRefSPay }));
        }
    }

    ngOnInit() {
        var data = localStorage.getItem("InfoPermission");
        if (data) {
            let info = JSON.parse(data);
            this.isRefSPay = info.IsRefSpay;
        }
    }

    @HostListener('touchstart', ['$event'])
    @HostListener('touchend', ['$event'])
    @HostListener('touchcancel', ['$event'])
    handleTouch(event) {
        let touch = event.touches[0] || event.changedTouches[0];
        if (event.type === 'touchstart') {
            this.defaultTouch.x = touch.pageX;
            this.defaultTouch.y = touch.pageY;
            this.defaultTouch.time = event.timeStamp;
        } else if (event.type === 'touchend') {
            let deltaX = touch.pageX - this.defaultTouch.x;
            let deltaTime = event.timeStamp - this.defaultTouch.time;

            if (deltaTime < 500) {
                if (Math.abs(deltaX) > 60) {
                    if (deltaX > 0) {
                        this.doSwipeRight(event);
                    } else {
                        this.doSwipeLeft(event);
                    }
                }
            }
        }
    }

    doSwipeLeft(event) {
        if (this.idx == 0) {
            this.preHandle = 'L';
            this.idx += 1;
        }
        else if (this.idx == 1 && this.preHandle == 'R') {
            this.idx += 1;
            this.preHandle = 'L';
        }
        else if (this.idx == 1 && this.preHandle == 'L') {
            this.idx += 1;
            this.preHandle = 'L';
        }
        else if (this.idx == 2) {
            this.idx = 0;
            this.preHandle = 'L';
        }
        console.log(this.idx);

    }

    doSwipeRight(event) {
        if (this.idx == 0) {
            this.idx += 2;
            this.preHandle = 'R';
        }
        else if (this.idx == 1 && this.preHandle == 'R') {
            this.idx -= 1;
            this.preHandle = 'R';
        }
        else if (this.idx == 1 && this.preHandle == 'L') {
            this.preHandle = 'R';
            this.idx -= 1;
        }
        else if (this.idx == 2 && this.preHandle == 'R') {
            this.preHandle = 'R';
            this.idx -= 1;
        }
        else if (this.idx == 2 && this.preHandle == 'L') {
            this.preHandle = 'R';
            this.idx -= 1;
        }
        console.log(this.idx);
    }

    ChangeIdx(idx) {
        this.idx = idx;
    }
}
